module.exports = __webpack_public_path__ + "img/racecourse-mauritius-turf-1365.44cd3139.svg";